import { useCountryConfig } from "../hooks/useCountryConfig";

export function AccountVerification() {
  const { AccountActivation } = useCountryConfig();

  return <AccountActivation title="account_validation.title" />;
}

export function RppsNumberVerification() {
  const { AccountActivation } = useCountryConfig();

  return <AccountActivation title="account_validation.rpps_verification" />;
}
